import { useState } from 'react';
import { EYMActions } from '~/processes/providers/yandexMetrika/entity';
import { useYandexHit } from '~/processes/providers/yandexMetrika/hooks/useYandexHit';
import type { ICloudPaymentData } from '../api/paymentCard';
import { cloudPayment } from '../api/paymentCard';
import { ERoutes } from '~/processes/routes';
import { useNavigate } from 'react-router-dom';
import { useStore } from '~/shared/hooks/useStore';

type TQRPayment = [() => Promise<void>, boolean, boolean];

export const useCardPayment = (contr_id: number, cloudPaymentData: ICloudPaymentData): TQRPayment => {
    const navigate = useNavigate();
    const { ymHit } = useYandexHit();
    const { COrder } = useStore();
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<boolean>(false);

    const cardPayment = async () => {
        setLoading(true);

        const actualAmount = COrder.order.order_info.need_to_pay;

        const callbacks = {
            onComplete(paymentResult: any) {
                navigate(paymentResult.success ? ERoutes.PAYMENT_SUCCESS : ERoutes.PAYMENT_ERROR);
                setLoading(false);
            },
            onFail() {
                navigate(ERoutes.PAYMENT_ERROR);
                setError(true);
                setLoading(false);
            },
            onSuccess() {
                navigate(ERoutes.PAYMENT_SUCCESS);
                setError(false);
                setLoading(false);
            },
        };

        try {
            await cloudPayment(contr_id, {
                ...cloudPaymentData,
                amount: actualAmount,
            }, callbacks);
            ymHit(EYMActions.PAYMENT_CARD);
        } catch (err) {
            navigate(ERoutes.PAYMENT_ERROR);
            setError(true);
            setLoading(false);
        }
    };

    return [cardPayment, loading, error];
};